import { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faEdit, faFolderOpen, faTrash, faPlus, faPeopleArrows, faVideo, faFolderClosed, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons"
import { useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { Tooltip } from "react-tooltip"
import ReactJson from "@microlink/react-json-view"
import { CaseArchiveTable } from "./Case";
import useAuth from "../hook/useAuth";
import useDeepVinApi from "../hook/useDeepvinApi";
import { useArchives } from "../hook/DataProvider";

export const Archives = () =>  {
  const { auth } = useAuth()
  const api = useDeepVinApi()
  const archives = useArchives() // array of struct {Archive, NumVids, NumCases}
  const [showArchiveModal, setShowArchiveModal] = useState(false)
  const [flag, setFlag] = useState(false)
  const { uuid } = useParams() // This is for deepvin only (from <DeepvinOnlyRoute>), uuid is for account
  
  const isDeepvinAdmin = auth.AccountID === 1 && uuid && uuid !== auth.Account.UUID
 
  const [idToShown, setIDToShown] = useState(0)
  // const [archiveToShown, setArchiveToShown] = useState()
  
  const refresh = (id) => {
    setFlag(!flag)
    if (id !== undefined) {
        setIDToShown(id)
    } else if (archives?.length>0){
        setIDToShown(archives[0].Archive.ID)
    }
  }
  const archivesChanged = () => {
    setFlag(!flag)
  }
      
  useEffect(() => {
    if (idToShown===undefined && archives.length > 0) {
        setIDToShown(archives[0].Archive.ID)
    }
  }, [flag])
 
  const handleNewArchive = () => {
    setShowArchiveModal(true)
    setIDToShown(0)
  }
  const handleEditArchive = () => {
    setShowArchiveModal(true)
  }

  const noSelArc = ()=>{
    return idToShown===undefined || idToShown===0
  }

  const handleShareArchive = () => {
    if (noSelArc()) return
   
    const arc = archives.find((a) => a.Archive.ID === idToShown)
    if (!arc) return

    if (!window.confirm(`Are you sure to change Sharing Videos for the folder: ${arc.Archive.Name}?`)) return

    api.post(`/api/archive/${idToShown}`, {Shared: !arc.Archive.Shared})
    .then(({data}) => {
      refresh(data.ID)
      toast.success(`Sharing videos for folder changed: ${data.Name}`)})
    .catch((error) => {
      if (error.response?.data) {
        toast.error(`Error: ${error.response.data.error}`)
      }
    })
  }
  
//   console.log("archives, idToShow", archives, idToShown)
  const handleDeleteArchive = () => {
    if (noSelArc()) return
   
    const arc = archives.find((a) => a.Archive.ID === idToShown)
    if (!arc) return

    if (window.confirm(`Are you sure you want to delete the folder, ${arc.Archive.Name}? The videos will be moved to Teams & Videos table.`)) {
        api.delete(`/api/archive/${idToShown}`)
        .then(({data}) => {
          refresh()
          toast.success("Folder deleted successfully.")}
        )
        .catch(error => {
          if (error.response.data) {
            toast.error(`Error: ${error.response.data.error}`)
          } else { console.error("API error: ", error) }
        })     
      }
  }

  const editArchiveButton = 
    <div class="btn-group">
    <button class="btn btn-sm btn-outline-secondary" id="btn-add-archive"  onClick={()=>handleNewArchive()} >
        <FontAwesomeIcon icon={faPlus} /></button>
    &nbsp;&nbsp;
    <button class="btn btn-sm btn-outline-secondary" id="btn-edit-archive"  onClick={()=>handleEditArchive()} 
         disabled={noSelArc()}><FontAwesomeIcon icon={faEdit} /></button>
    {/* <button class="btn btn-sm btn-outline-secondary" id="btn-share-archive" onClick={()=>handleShareArchive()} 
        disabled={noSelArc()}><FontAwesomeIcon icon={faPeopleArrows} /></button> */}
    <button type="button" class="btn btn-sm btn-outline-secondary" id="btn-delete-archive" onClick={()=>handleDeleteArchive()} 
        disabled={noSelArc()}><FontAwesomeIcon icon={faTrash} /></button>
    </div> 

  if (archives) {
  return (
  <>
    {/* <div className="row">
      <div>
        <ArchiveSelector archives={archives} arcId={archives.length>0 ? archives[0].ID : undefined} setArcId={setArcId} />
      </div>
      <button class="btn btn-outline-secondary me-3" onClick={()=>setShowAccountModal(true)}><FontAwesomeIcon icon={faEdit} /></button>
    </div> */}

    <div style={{display: 'flex', gap: '10px'}}>
        <div class="pe-0" style={{width: '18rem'}}>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="bg-info fw-bold"><FontAwesomeIcon icon={faArchive} />&nbsp;&nbsp;Cases</th>
              </tr>
            </thead>
            <tbody>
              {archives.map(arc => (auth.IsRoot || arc.NumCases > 0) &&
              <ArchiveTab arc={arc} refresh={refresh} coloredID={idToShown}/>)}
              <tr>
                <td class="text-center">
                  {/* <div class="col-4 mb-3"><ExportPDFButton /></div> */}
                  {auth && auth.IsRoot && editArchiveButton}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {idToShown !== undefined && <div class="" style={{flexGrow: 2}}>
            <h2>Cases</h2>
            <hr />
            <CaseArchiveTable archives={archives} archiveID={idToShown} refresh={archivesChanged}/>
        </div>}
      </div>      
  
      <Tooltip anchorSelect="#btn-add-archive" place="top">Create folder</Tooltip>
      <Tooltip anchorSelect="#btn-delete-archive" place="top">Delete selected folder</Tooltip>
      <Tooltip anchorSelect="#btn-edit-archive">Edit selected folder</Tooltip>
      {/* <Tooltip anchorSelect="#btn-share-archive">{archiveToShown?.Shared ? 'Disable' : 'Enable'} sharing videos in folder</Tooltip> */}
  

    {<ArchiveModal archives={archives} show={showArchiveModal} setShow={setShowArchiveModal} refresh={refresh} arcId={idToShown}/>}
  </>
  )}
}

const ArchiveModal = ({archives, show, setShow, refresh, arcId}) => {
  const api = useDeepVinApi()
    const [archiveName, setArchiveName] = useState("")
    
    const newArc = () => { return arcId===undefined || arcId===0}

    const onHide = () => setShow(false)

    const nameExists = (name)=> {
        return archives?.filter(a=>a.Archive.Name === name).length > 0
    }
    const validInput = (input) => {
        if (input === "") {
            alert("The folder name cannot be empty or just white spaces.")
            return false
        }
        if (nameExists(input)){
            alert("The folder name already exists.")
            return false
        }
        return true
    }

    const handleSubmit = () => {
        const trimmedInput = archiveName.trim();
        if (!validInput(trimmedInput)) return

        let apiUrl = newArc() ? `/api/archive/new` : `/api/archive/${arcId}/rename`
        api.post(apiUrl, {Name: trimmedInput})
        .then(({data}) => {
            setArchiveName("")
            refresh(data.ID)
            // toast.success(`Folder ${data.Name} added successfully.`)
        })
        .catch((error) => {
          if (error.response.data) {
          toast.error(`Error: ${error.response.data.error}`)
          }
        })
       setShow(false)
    }
    
    const arcName = newArc() ? "" : GetArchiveName(arcId, archives)
    const title = newArc() ? "Add New Folder" : "Rename Folder: " + arcName
    // console.log("ArchiveModal archives, arcId, arcName", archives, arcId, arcName)
    return (
      <Modal show={show} onHide={onHide} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-group mb-3">
            <input type="text" class="form-control" placeholder={newArc() ? "Name of new folder" : arcName} 
                aria-label="Folder name"
                aria-describedby="basic-addon2" value={archiveName} onChange={e=>setArchiveName(e.target.value)}/>
            {/* <button class="btn btn-outline-secondary me-3" onClick={handleSubmit}>Add Folder</button> */}
          </div>
          
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>Submit</Button>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
        </Modal.Footer>
      </Modal>  
    )
}

export const ArchiveSelector = ({archives, arcId, setArcId}) => {

    const handleSelect = (e) => {
        if (setArcId) setArcId(parseInt(e.target.value))
    //   setData({...data, ["ArchiveID"]: parseInt(e.target.value)})
    }
  
    if (archives)
    return (
      <select class="form-select" name="archiveAssigned"
        value={arcId===undefined ? "" : arcId}
        onChange={handleSelect}>
          <option selected>Select archive</option>
          {archives.map(item => <option value={item.Archive.ID}>{item.Archive.Name}</option>)}
      </select>
    )
}

export const GetArchiveName = (aid, archives) => {
  const arc = archives && archives.find((a) => a.Archive.ID === aid)
  return arc ? arc.Archive.Name : ""
}

export const ArchiveTab = ({arc, refresh, coloredID}) => {
    const archive = arc?.Archive 
    if (archive)
    return (
      // <div onClick={handleClickOutside} style={{ position: "relative" }}>
      <>
      <tr class={coloredID === archive.ID ? "table-info" : ""} onClick={()=>refresh(archive.ID)}>
        <td>
          <FontAwesomeIcon icon={archive.ID===0 ? faFolderOpen : faFolderClosed} /> &nbsp; 
          {archive.Name && archive.Name} &nbsp; 
          {arc.NumCases !== undefined
          ? <span class="badge rounded-pill bg-info" style={{textIndent: '0px'}}><FontAwesomeIcon icon={faVideo} /> {arc.NumCases}</span>
          : ""
          }&nbsp; 
          {/* {archive.Shared
          ? <span class="badge rounded-pill bg-warning" id="span-arc-share" style={{textIndent: '0px'}}><FontAwesomeIcon icon={faPeopleArrows} /></span>
          : ""
          } */}
        </td>
      </tr>
      <Tooltip anchorSelect="#span-arc-share" arrowColor="#222222">Sharing videos in folder</Tooltip>
      </>
    )
  }


export const ArchiveMoveMenu = ({archives, setArcId}) => {

    // const handleSelect = (e) => {
    //     if (setArcId) setArcId(parseInt(e.target.value))
    // //   setData({...data, ["ArchiveID"]: parseInt(e.target.value)})
    // }
  
    if (archives)
    return (
    <>
      <div id='archive-move-menu' class="dropdown">
        <a href="#" class="text-decoration-none dropdown-toggle py-0 me-0" id="dropdownArchives" data-bs-toggle="dropdown" aria-expanded="false">
          <FontAwesomeIcon size='sm' icon={faArrowRightFromBracket} />
        </a>
        <ul class="dropdown-menu text-small shadow" aria-labelledby="dropdownArchives">
          {archives.map(item => <li><a class="dropdown-item" href="#" onClick={()=>setArcId(item.Archive.ID)}>{item.Archive.Name}</a></li>)}
        </ul>
      </div>

      {/* <select class="form-select" name="archiveAssigned"
        value={arcId===undefined ? "" : arcId}
        onChange={handleSelect}>
          <option selected>Select archive</option>
          {archives.map(item => <option value={item.Archive.ID}>{item.Archive.Name}</option>)}
      </select> */}
      <Tooltip anchorSelect="#archive-move-menu" place="top">Move selected to folder...</Tooltip>

    </>
    )
}

export const ArchiveMoveButton = ({arcId, caseNum}) => {

  const archives = useArchives()
  const [archiveID, setArchiveID] = useState(arcId)
  const arc = archives?.find(a=>a.Archive.ID===arcId)
  const oriName = arc ? arc.Archive.Name : "Active"
  const [arcName, setArcName] = useState("Active");

  useEffect(() => {
    setArcName(oriName);
  }, [oriName]);
  useEffect(() => {
    setArchiveID(arcId);
  }, [arcId]);

  // console.log("arc, archiveID, arcId, origName, arcName", arc, archiveID, arcId, oriName, arcName)
  const api = useDeepVinApi()

  const setArcId = (selArchive) => {
    let caseNums = [caseNum]
    // console.log("selArchive: ", selArchive)
    if (selArchive === undefined || selArchive === archiveID) return

    api.post(`/api/archive/${selArchive}/case`, caseNums)
      .then(({}) => {
        setArchiveID(selArchive)
        let newName = archives.find(a=>a.Archive.ID===selArchive)?.Archive.Name
        setArcName(newName)
        // console.log("new arc Name: ", newName)
        toast.success("Case is moved successfully")
      })
      .catch((error) => {
        toast.error(error.response?.data?.error)
      })
  }

    if (archives?.length > 0)
    return (
    <>
      <div id='archive-move-button' className="dropdown">
        <button
          className="btn btn-outline-primary dropdown-toggle"
          id="dropdownArchives"
          data-bs-toggle="dropdown"
        >
          <FontAwesomeIcon size='sm' icon={faArchive} /> {arcName}{/* <FontAwesomeIcon size='sm' icon={faArrowRightFromBracket} />*/}
        </button>

        <ul className="dropdown-menu" aria-labelledby="dropdownArchives">
          {archives.map(item => (
            <li key={item.Archive.ID}>
              <a className="dropdown-item" href="#" style={{ color: '#212529' }}onClick={() => setArcId(item.Archive.ID)}>
                {item.Archive.Name}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <Tooltip anchorSelect="#archive-move-button" place="top">Move to Archive ...</Tooltip>

    </>
    )
}
